import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

// Material Module
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatButtonModule } from '@angular/material/button'
import { MatSelectModule } from '@angular/material/select'
import { MatMenuModule } from '@angular/material/menu'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatIconModule } from '@angular/material/icon'
import { MatCardModule } from '@angular/material/card'
import { MatRadioModule } from '@angular/material/radio'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatTableModule } from '@angular/material/table'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatChipsModule } from '@angular/material/chips'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSortModule } from '@angular/material/sort'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatListModule } from '@angular/material/list'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatAutocompleteModule } from '@angular/material/autocomplete'

@NgModule({
	declarations: [],
	imports: [CommonModule],
	exports: [
		MatButtonToggleModule,
		MatButtonModule,
		MatSelectModule,
		MatMenuModule,
		MatDialogModule,
		MatFormFieldModule,
		MatInputModule,
		MatTabsModule,
		MatSidenavModule,
		MatIconModule,
		MatCardModule,
		MatRadioModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatExpansionModule,
		MatTableModule,
		MatCheckboxModule,
		MatChipsModule,
		MatPaginatorModule,
		MatSortModule,
		MatTooltipModule,
		MatProgressSpinnerModule,
		MatListModule,
		MatSnackBarModule,
		MatAutocompleteModule,
	],
})
export class MaterialModule {}
